import * as React from 'react';
import './Caret.scss';

/** The ledger's caret: points at the row's children, and down once open. */
export const Caret: React.FC = () => (
  <svg
    className="tree-ledger-caret"
    viewBox="0 0 10 10"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M3 1 L7.5 5 L3 9 Z" />
  </svg>
);
